// extracted by mini-css-extract-plugin
export default {"summary":"TaskLinkPage_summary__oEk9q","title":"TaskLinkPage_title__XQDWn"};